import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { SectionNavItem } from './SectionNavItem';

export function SectionNavbar({ navItems, tabBarClassName }) {
  const [selectedItem, setSelectedItem] = useState(0);
  const visibleComponent = navItems[selectedItem].component;

  return (
    <div
      className={cn(
        'glass-panel glass-panel-interactive mx-auto w-full max-w-[1440px] overflow-hidden px-3 py-5 sm:px-6 sm:py-6',
        tabBarClassName,
      )}
    >
      <nav aria-label="Dashboard sections">
        <ul
          role="tablist"
          className="mb-6 flex list-none flex-wrap gap-x-8 gap-y-1 border-b border-black/[0.08] px-1 sm:gap-x-10 sm:px-2"
        >
          {navItems.map((navItem, index) => (
            <li
              key={navItem.title}
              className="shrink-0 list-none"
              role="presentation"
            >
              <SectionNavItem
                id={`home-tab-${index}`}
                title={navItem.title}
                index={index}
                isSelected={selectedItem === index}
                handleSelectionChanged={setSelectedItem}
                aria-controls={`home-tabpanel-${index}`}
              />
            </li>
          ))}
        </ul>
      </nav>
      <div
        role="tabpanel"
        id={`home-tabpanel-${selectedItem}`}
        tabIndex={0}
        aria-labelledby={`home-tab-${selectedItem}`}
        className="min-w-0 px-0 pb-2 pt-0"
      >
        {visibleComponent}
      </div>
    </div>
  );
}
